<div class="sign-detail">

    <mat-tab-group [(selectedIndex)]="signTabIndex" class="tabs" dynamicHeight>

        @for (signId of signs; track signId) {
            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="label">
                        <img alt="{{'SIGN.' + signId.toUpperCase() | translate}}"
                              src="assets/images/sign/{{signId}}.webp">
                        {{ 'SIGN.' + signId.toUpperCase() | translate }}
                    </div>
                </ng-template>
                <article class="description">
                    <h2>
                        {{ 'SIGN.' + signId.toUpperCase() | translate }}
                    </h2>
                    <div class="content-block">
                        <h3>
                            {{ 'SIGN_GENERAL.TITLE' | translate }}
                        </h3>
                        <div class="general-info">
                            <p class="tag">{{ 'ATTRIBUTE.ELEMENT' | translate }}</p>
                            <p>{{ 'ELEMENT.' + getElement().toUpperCase() | translate }}</p>
                            <p class="tag">{{ 'ATTRIBUTE.GARDEN' | translate }}</p>
                            <p>{{ 'GARDEN.' + getGarden().toUpperCase() | translate }}</p>
                            <p class="tag">{{ 'ATTRIBUTE.BODY_PART' | translate }}</p>
                            <p> {{ 'ATTRIBUTE.BODY_PARTS.' + getActiveSign().toUpperCase() | translate }}</p>
                            <p class="tag">{{ 'ATTRIBUTE.ORGAN_SYSTEM' | translate }}</p>
                            <p>{{ 'ATTRIBUTE.ORGAN_SYSTEMS.' + getOrganSystem().toUpperCase() | translate }}</p>
                            <p class="tag">{{ 'ATTRIBUTE.NUTRITION_QUALITY' | translate }}</p>
                            <p>{{ 'NUTRITION.' + getNutritionQuality().toUpperCase() | translate }}</p>
                            <p class="tag">{{ 'ATTRIBUTE.DAY_QUALITY' | translate }}</p>
                            <p>{{ 'DAY_QUALITY.' + getDayQuality().toUpperCase() | translate }}</p>
                        </div>
                        <h3 class="sign-garden">
                            {{ 'SIGN_GARDEN.TITLE' | translate }}
                        </h3>
                        <p [innerHTML]="'SIGN_GARDEN.' + getGardenId().toUpperCase()  | translate"></p>
                    </div>
                </article>
            </mat-tab>
        }

    </mat-tab-group>


</div>
